import React from "react";
import { Link } from "react-router-dom";

import btnWhatsapp from "../../assets/img/whp-btn-whatsapp.svg";
import btnYT from "../../assets/img/ico-youtube.svg";

const VideoCuponComponent = ({ videoCreated, isCode }) => {
    console.log(isCode);

    return (
        <div className="video-cupon-component pb-5 pb-md-0">
            {(isCode === true)
                ? (videoCreated.years >= 5)
                    ? (videoCreated.cupon != null)
                        ? (<>
                            <h3>Tu descuento es de <strong>{videoCreated.cupon.off}</strong> </h3>
                            <p className="mb-3">para compras de lavadoras en <a href="https://www.whirlpool.mx/" target="_blank" rel="noreferrer" >Whirlpool.mx</a> </p>
                            <p>
                                Tu código de descuento
                                <span href="" className="btn btn-primary d-block mt-3">
                                    {videoCreated.cupon.cupon}
                                </span>
                                <small className="mt-3">Válido del 1 de noviembre al 31 de diciembre del 2024 para compras en <a href="https://www.whirlpool.mx/" target="_blank" rel="noreferrer" >whirlpool.mx.</a>  Consulta <Link to='termsConditions'>términos y condiciones.</Link> </small>
                            </p>
                        </>)
                        : (<>
                            <p>Con el baile de tu lavadora detectamos que quizá solo necesita un meneito, es decir, un balanceo.</p>
                            <p>Ve esta guía para saber más!</p>
                            <a href="https://www.youtube.com/playlist?list=PLOh0RWIEtY30aOabSFXU6y6gk0OMXAYZE" target="_blank" rel="noreferrer">
                                <img src={btnYT} alt="Botón Youtube" style={{ height: '30px' }} />
                            </a>
                        </>)
                    : (videoCreated.washerBreand !== 'Otros')
                        ? (<>
                            <p>Con el baile de tu lavadora detectamos que quizá solo necesita un meneito, es decir, un balanceo.</p>
                            <p>¡Contáctanos para mas ayuda!</p>
                            <a href="https://api.whatsapp.com/send?phone=8125161867" target="_blank" rel="noreferrer">
                                <img src={btnWhatsapp} alt="Botón whatsapp" style={{ height: '80px' }} />
                            </a>
                        </>)
                        : (<>
                            <p>Con el baile de tu lavadora detectamos que quizá solo necesita un meneito, es decir, un balanceo.</p>
                            <p>Ve esta guía para saber más!</p>
                            <a href="https://www.youtube.com/playlist?list=PLOh0RWIEtY30aOabSFXU6y6gk0OMXAYZE" target="_blank" rel="noreferrer">
                                <img src={btnYT} alt="Botón Youtube" style={{ height: '30px' }} />
                            </a>
                        </>)
                : (<>
                    <p>Ve esta guía para saber más!</p>
                    <a href="https://www.youtube.com/playlist?list=PLOh0RWIEtY30aOabSFXU6y6gk0OMXAYZE" className="d-block mb-4" target="_blank" rel="noreferrer">
                        <img src={btnYT} alt="Botón Youtube" style={{ height: '30px' }} />
                    </a>
                </>)
            }
        </div >
    )
};

export default VideoCuponComponent;